export { Skeleton, type SkeletonProps } from "#skeleton";
export {
  SkeletonAccordionHeader,
  SkeletonAccordionSection,
  SkeletonBadge,
  SkeletonGroup,
  SkeletonSurfaceHeader,
  SkeletonTile,
  SkeletonTileGrid,
  SkeletonTileSurface,
} from "#skeleton-blocks";
